<template>
  <div class="hero-section">
    <!-- Navigation Indicator -->
    <div class="nav-indicator">
      <span v-for="(item, index) in navIndicator" :key="index">
        <!-- Wrap both the icon and text in the <a> tag if item.link exists -->
        <a v-if="item.link" :href="item.link" class="nav-link">
          <img
            v-if="item.icon"
            :src="homeIcon"
            alt="Home Icon"
            class="nav-icon"
          />
          {{ item.text }}
        </a>
        <!-- Render as a span if there's no link -->
        <span v-else>{{ item.text }}</span>
        <span v-if="index < navIndicator.length - 1"> > </span>
      </span>
    </div>
    
    <!-- Main Hero Content -->
    <div class="hero-content">
      <div class="text-content">
        <h1>{{ title }}</h1>
        <div class="image-content">
          <img :src="image" alt="DIVACS Banner" />
        </div>
        <p>{{ description }}</p>
        <a :href="buttonLink" class="btn">{{ buttonText }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroSection',
  props: {
    title: String,
    description: String,
    buttonText: String,
    buttonLink: String,
    image: String,
    navIndicator: Array,
  },
  data() {
    return {
      // Define the home icon path using require
      homeIcon: require('@/assets/img/nav-home-icon.png'),
    };
  },
  mounted() {
    let slider = document.querySelector('.swiper-wrapper');
    slider;
  },
};
</script>

<style scoped>
.hero-section {
  background: #F7F8FC;
  padding: 40px 20px;
  position: relative;
  min-height: 600px; /* Adjust height to ensure the bottom border aligns with the middle of the sidebar */
}

.nav-indicator {
  font-size: 14px;
  color: #666;
  max-width: 1230px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

/* Style the nav icon image */
.nav-icon {
  width: 16px; /* Adjust size as needed */
  height: 16px;
  vertical-align: middle;
  margin-right: 5px;
  margin-bottom: 5px;
}

/* Style the nav link to ensure icon and text are aligned */
.nav-link {
  display: inline-flex;
  align-items: center;
  color: #666;
  text-decoration: none;
}

.nav-link:hover {
  text-decoration: underline;
}

.nav-indicator span {
  margin-right: 1px;
}

.nav-indicator a,
.nav-indicator span {
  cursor: pointer;
  color: #666;
  text-decoration: none;
}

.hero-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1230px;
  margin: 0 auto;
}

.text-content {
  text-align: left;
}

h1 {
  font-size: 58px;
  margin-bottom: 20px;
  color: #333;
}

h2 {
  font-size: 28px;
  color: #1e3a8a;
  margin-bottom: 20px;
}

p {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}

.btn {
  display: inline-block;
  padding: 10px 20px;
  background-color: #007AB2;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
}

.btn:hover {
  background: #00AEFF;
}

.image-content {
  margin-bottom: 1rem;
}

.image-content img {
  width: 100%;
  border-radius: 10px;
}

@media (max-width: 768px) {
  .hero-section {
    min-height: auto;
  }

  .hero-content {
    flex-direction: column;
  }

  .text-content,
  .image-content {
    max-width: 100%;
  }

  h1 {
    font-size: 32px;
  }

  h2 {
    font-size: 24px;
  }
}
@media screen and (max-width: 1475px) {
  .hero-section {
    padding: 4rem 4rem 4rem 10rem;
  }
  
}
@media screen and (max-width: 1370px) {
  .hero-section {
    padding: 4rem 1rem 4rem 6rem;
  }
}
@media screen and (max-width: 1280px) {
  .hero-section {
    padding: 4rem 4rem 4rem 5rem;
  }
}
@media screen and (max-width: 1100px) {
  .hero-section {
    padding: 4rem;
  }
}
@media screen and (max-width: 800px) {
  .hero-section {
    padding: 4rem 3rem;
  }
}

@media screen and (max-width: 730px) {
  
  .hero-section {
    padding: 4rem 2rem;
  }
}
@media screen and (max-width: 490px) {
  .hero-section {
    padding: 4rem 1rem 4rem 2rem;
  }
}
</style>